<template>
  <div class="clearWatermark">
    <div class="lab">
      不加水印
    </div>
    <div class="watermarkSwitch">
      <el-switch
        :value="clearWatermark"
        :width="30"
        active-color="#3058FE"
        inactive-color="#E0E2EA"
        @change="change"
      ></el-switch>
      <div class="free">
        <iconfont
          name="#icon11-111xianmian"
          font-size="30px"
        ></iconfont>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClearWatermark',
  components: {},
  model: {
    prop: 'clearWatermark',
    event: 'switch'
  },
  props: {
    clearWatermark: { type: Boolean, default: true }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    change(value) {
      this.$emit('switch', value);
      if (value) {
        window.localStorage.setItem('watermark-switch', true);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.clearWatermark {
  display: flex;
  justify-self: start;
  align-items: center;
  .lab {
    margin-left: auto;
    height: 14px;
    line-height: 14px;
    color: #343434;
  }
  @media screen and (max-width: 1600px) {
    .lab {
      font-size: 12px;
      margin-right: 6px;
    }
    .watermarkSwitch {
      position: relative;
      margin-right: 17px;
      .free {
        position: absolute;
        top: -140%;
        right: -55%;
        width: 26px;
        height: 12px;
      }
    }
  }
  @media screen and (min-width: 1600px) {
    .lab {
      font-size: 14px;
      margin-right: 9px;
    }
    .watermarkSwitch {
      position: relative;
      margin-right: 21px;
      .free {
        position: absolute;
        top: -140%;
        right: -70%;
        width: 30px;
        height: 14px;
      }
    }
  }
}
</style>
<style lang="scss">
.watermarkSwitch {
  .el-switch {
    height: 16px;
    .el-switch__core {
      height: 16px;
      line-height: 16px;
      width: 30px;
      &:after {
        height: 12px;
        width: 12px;
      }
    }
  }
  .el-switch.is-checked .el-switch__core::after {
    left: 100%;
    margin-left: -13px;
  }
}
</style>
